import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

// Reused across both record keys (per docs/packages/experiments/i18n-copy.md's "FC:
// multiple variants" recipe) — I18nOverrides only ever receives one variant's resolved
// dictionary at a time (see provider.tsx), so both entries can share the same leaf key.
const variantCopyShape = {
	type: 'object',
	shape: {
		fe: {
			type: 'object',
			shape: {
				components: {
					type: 'object',
					shape: {
						petition_share: {
							type: 'object',
							shape: {
								action_variant: { type: 'string' },
							},
						},
					},
				},
			},
		},
	},
} as const;

export const FCM_PETITION_DETAILS_SHARE_CTA_COPY_LABELS = defineFcm('petition_details_share_cta_copy_labels')
	.asJson(
		createShapeNormalizer({
			type: 'record',
			keys: ['variant_1', 'variant_2'] as const,
			shape: variantCopyShape,
		}),
	)
	.withDefault({
		variant_1: {
			fe: {
				components: {
					petition_share: {
						action_variant: 'Share petition',
					},
				},
			},
		},
		variant_2: {
			fe: {
				components: {
					petition_share: {
						action_variant: 'Share',
					},
				},
			},
		},
	})
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Mobile Action Button',
		description:
			'Locale-aware, per-variant copy for petition_details_share_cta_copy_experiment (variant_1: "Share petition", variant_2: "Share"). control needs no entry — it renders the existing, unchanged fe.components.petition_share.action key. fake_control is always rendered with the control payload by the front-end (A/A) — no need to set it.\n\nhttps://change.atlassian.net/browse/CHANGE-97578',
		supportedGroups: { global: true, locales: true },
		template: {
			variant_1: {
				fe: {
					components: {
						petition_share: {
							action_variant: 'Share petition',
						},
					},
				},
			},
			variant_2: {
				fe: {
					components: {
						petition_share: {
							action_variant: 'Share',
						},
					},
				},
			},
		},
	});
